import { Controller } from "@hotwired/stimulus"

// Per-weekday von/bis break editor for the seasonal working-hours form. Adds and
// removes plain (non-ActiveRecord) input rows named
// timesheet_template_working_hour[day_details][<day>][break_periods][<i>][from|to],
// and shows a live read-only total of the day's break minutes.
// Each weekday cell is its own controller instance; row indices only need to be
// unique within the cell, so a timestamp placeholder is used for new rows.
export default class extends Controller {
  static targets = ["rows", "template", "total"]

  connect() {
    this._recompute = this.recompute.bind(this)
    this.element.addEventListener("input", this._recompute)
    this.element.addEventListener("click", this._recompute)
    this.recompute()
  }

  disconnect() {
    this.element.removeEventListener("input", this._recompute)
    this.element.removeEventListener("click", this._recompute)
  }

  add(event) {
    event.preventDefault()
    const html = this.templateTarget.innerHTML.replaceAll("NEW_RECORD", new Date().getTime())
    this.rowsTarget.insertAdjacentHTML("beforeend", html)
    this.recompute()
  }

  remove(event) {
    event.preventDefault()
    event.target.closest("[data-seasonal-day-breaks-target='row']")?.remove()
    this.recompute()
  }

  recompute() {
    if (!this.hasTotalTarget) return

    let minutes = 0
    this.rowsTarget.querySelectorAll("[data-seasonal-day-breaks-target='row']").forEach((row) => {
      const from = this._minutes(row.querySelector("input[name$='[from]']"))
      const to = this._minutes(row.querySelector("input[name$='[to]']"))
      if (from !== null && to !== null && to > from) minutes += to - from
    })

    this.totalTarget.textContent = minutes > 0 ? `= ${minutes} Min.` : ""
  }

  _minutes(input) {
    const value = input && input.value
    if (!value || !value.includes(":")) return null

    const [h, m] = value.split(":").map((n) => parseInt(n, 10))
    if (Number.isNaN(h) || Number.isNaN(m)) return null

    return h * 60 + m
  }
}
